import { useEffect } from "react";

/**
 * Sends a "preferred scenario" hint to the Android wrapper so it can switch
 * the active RFID power profile based on the page the operator is viewing.
 *
 * Implementation: dispatches a CustomEvent on `window` that MainActivity's
 * WebChromeClient picks up via JavaScript bridge — see the wrapper's
 * setScenarioByName JS hook. If we're not running inside the wrapper this
 * is a complete no-op.
 *
 * Naming convention matches the scenario defaults baked into the APK:
 *   Dispatch · Receiving · Stocktake · Register · Delete
 */
export default function usePdaScenarioHint(name) {
  useEffect(() => {
    if (!name) return;
    try {
      // 1) Direct bridge (preferred — Android wrapper >= v1.14 exposes DrrtPda)
      if (window.DrrtPda && typeof window.DrrtPda.setScenarioByName === "function") {
        window.DrrtPda.setScenarioByName(name);
      }
      // 2) Fallback event — also harmless on the desktop browser.
      window.dispatchEvent(new CustomEvent("pda-set-scenario", { detail: { name } }));
    } catch {
      /* ignored — wrapper not present */
    }
  }, [name]);
}
